const Confirmation = ({ popup, setPopup, text, action, busy }) => {
  return (
    <div
      className={
        popup.open === true
          ? "modal fade effect-slide-in-bottom show bg-success-transparent"
          : "modal fade effect-slide-in-bottom"
      }
      style={popup.open === true ? { display: "block" } : {}}
    >
      <div
        className="modal-dialog modal-dialog-centered modal-sm"
        role="document"
      >
        <div className="modal-content modal-content-demo">
          <div className="modal-header">
            <h6 className="modal-title">{text}</h6>
            <button
              onClick={() => {
                setPopup({ open: false, data: "" });
              }}
              aria-label="Close"
              className="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>
          <div className="modal-body">
            <div className="text-center">
              <h5>Are You Sure?</h5>
            </div>
          </div>
          <div className="modal-footer">
            <div className="w-100 d-flex justify-content-center gap-2">
              <button
                onClick={() => {
                  setPopup({ open: false, data: "" });
                }}
                className="btn btn-danger"
                type="button"
              >
                No
              </button>
              <button
                onClick={action}
                className="btn btn-primary"
                type="button"
                disabled={busy ?? false}
              >
                {busy === true ? (
                  <span
                    className="spinner-border spinner-border-xs"
                    role="status"
                    aria-hidden="true"
                  ></span>
                ) : (
                  "Confirm"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Confirmation;
